import baseReport from '../baseReport';
import formatDataBR from '@/plugins/filters/formatDataBR';

const montarAssinatura = (professores) => {
  return [
    {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          alignment: 'right',
          layout: 'noBorders',
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: 'center',
                  fontSize: 8,
                  margin: [15, 35, 15, 0],
                  text: [
                    '_____________________________________________\n',
                    'Assinatura do Professor/Educador\n',
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ],
                }])),
            ],
          },
        },
        { width: '*', text: '' },
      ],
    },
  ];
};

const pareceresDescritivosReport = async ({ date, time, filtros, data, periodos, periodo, professores, tipoDeEnsino, indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Parecer Circunstanciado' });

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [
        { text: 'Professor/Educador:   ', bold: true },
        nameProfessores,
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: 'Ano letivo:  ', bold: true },
            filtros.aaletivo,
            ...AnoSubsquente
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Turma:   ', bold: true },
            filtros.turma,
          ],
        },
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ? 'Campos de Experiência:   ' : 'Disciplina:   ', bold: true },
            filtros.disciplina,
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Período:   ', bold: true },
            filtros.periodo,
          ],
        },
      ],
    },
  ];

  if (data.length <= 0) {
    return {
      ...headerFooter,
      content: [{
        text: 'Nenhum parecer descritivo encontrado.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

  let periodosFiltered = periodos;
  periodosFiltered.shift();
  if (periodo !== '-1') { periodosFiltered = periodosFiltered.filter(key => key.value === periodo); }

  let contador = 0;
  const dataFormated = periodosFiltered.map((key) => {
    const pareceres = data.filter(n => n.cdpravadi === key.value).map((n) => {
      const situacaoFinal = [];
      if (n.indicasituacaofinal) {
        situacaoFinal.push({
          fontSize: 9,
          columns: [
            {
              text: [
                { text: 'Situação Final:   ', bold: true },
                ((n.indicasituacaofinal === 'R') ? 'Reprovado' : 'Aprovado'),
              ],
            },
          ],
        });
      }
      contador += 1;
      return [
        {
          margin: [0, 15, 0, 0],
          fontSize: 9,
          columns: [
            {
              text: [
                { text: 'Aluno:   ', bold: true },
                n.matricula.aluno.nmaluno,
              ],
            },
            {
              alignment: 'right',
              text: [
                { text: 'Matrícula:   ', bold: true },
                n.numatalun,
              ],
            },
          ],
        },
        {
          fontSize: 9,
          columns: [
            {
              text: [
                { text: 'Data da Avaliação:   ', bold: true },
                formatDataBR(n.dataparecer),
              ],
            },
            {
              alignment: 'right',
              text: [
                { text: 'Data de Nascimento:   ', bold: true },
                formatDataBR(n.matricula.aluno.dtnascim),
              ],
            },
            {
              alignment: 'right',
              text: [
                { text: 'Idade:   ', bold: true },
                n.matricula.aluno.idade,
              ],
            },
          ],
        },
        {
          fontSize: 9,
          columns: [
            {
              text: [
                { text: 'Endereço:   ', bold: true },
                `${n.matricula.aluno.tplograd.toUpperCase()} ${n.matricula.aluno.nmlogradm}, ${n.matricula.aluno.nuimovel} ${n.matricula.aluno.edcomplem} - ${n.matricula.aluno.nmcidadem}`,
              ],
            },
          ],
        },
        {
          fontSize: 9,
          columns: [
            {
              alignment: 'left',
              text: [
                { text: 'Responsáveis:   ', bold: true },
                `${n.matricula.aluno.nmpai}, ${n.matricula.aluno.nmmae}, ${n.matricula.aluno.nmfiliacao}`,
              ],
            },
          ],
        },
        ...situacaoFinal,
        {
          fontSize: 9,
          bold: true,
          margin: [0, 20, 0, 0],
          text: 'Aspecto Comportamental:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaoaspectocomportamental,
        },
        {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Percepção Visual e Memória Auditiva:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaovisualeauditiva,
        },
        {
          fontSize: 12,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Desenvolvimento Cognitivo',
        },
        {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Sistema de Leitura e Escrita:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaoleituraescrita,
        },
        {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Raciocínio Lógico:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaoraciociniologico,
        },
        {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Habilidades Motoras/Psicomotoras:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaohabilimotoraspsicomotoras,
        },
        {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Emocional/Afetivo/Social:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaoemocionalafetivosocial,
        },
        {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Linguagem Oral:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaoliguagemoral,
        },
        {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Estratégias Utilizadas:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaoestrategiasutilizadas,
        },
        {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 0],
          text: 'Observações:',
        },
        {
          fontSize: 9,
          margin: [3, 1, 0, 3],
          alignment: 'justify',
          text: n.descricaoobservacao,
        },

        ...montarAssinatura(professores),
        {
          text: '',
          pageBreak: ((contador !== data.length) ? 'after' : ''),
        },
      ];
    });
    if (pareceres.length <= 0) { return {}; }

    return [
      {
        text: `Período Avaliativo: ${key.text}`,
        alignment: 'center',
        bold: true,
        margin: [0, 15, 0, 0],
        fontSize: 10,
      },
      ...pareceres,
    ];
  });

  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...dataFormated,
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
        alignment: 'center',
      },
    },
  };
};

export default pareceresDescritivosReport;
